<template>
  <FullscreenFrontageDialog ref="frontageDialog">
    <template slot-scope="dialogProps">
      <NewNoteDialog :is-mobile="isMobile"
                     :is-entity="dialogProps.isEntity"
                     :matter-uid="matterUid"
                     :note-uid="noteUid"
                     @handle-close="handleClose"
                     @handle-submit="handleSubmit"/>
    </template>
  </FullscreenFrontageDialog>
</template>

<script>
import {FullscreenFrontageDialog} from "@/modules/common/components";
import NewNoteDialog from "@/modules/note/components/NewNoteDialog";
import {mapGetters} from "vuex";

export default {
  name: "NotePage",
  components: {FullscreenFrontageDialog, NewNoteDialog},
  props: {
    matterUid: {
      type: String,
      required: true
    },
    noteUid: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters(['isMobile'])
  },
  methods: {
    handleClose(data) {
      this.$refs.frontageDialog.handleClose(data);
    },
    handleSubmit(data) {
      this.$refs.frontageDialog.handleSubmit(data);
    }
  }
}
</script>
